import { useMutation } from '@tanstack/react-query';

import {
  PluginSubmitCreditDecisionRequest,
  PluginSubmitCreditDecisionResponse,
} from '../../../../types/plugins';
import { handleError } from '../../../../utils/admin';
import { useRequestConstructor } from '../../../hooks/useRequestConstructor';
import { getApiErrorMessage } from '../../../logic';
import { ApiErrorResponse } from '../../../types';
import { NonPaginatedResponse } from '../../../types/NonPaginatedResponse';
import { runSubmitCreditDecisionRequest } from '../../requests/runSubmitCreditDecisionRequest';

export const useRunSubmitCreditDecisionRequest = () => {
  const { constructPost } = useRequestConstructor();
  const { mutateAsync, ...rest } = useMutation<
    NonPaginatedResponse<PluginSubmitCreditDecisionResponse> | undefined,
    Error,
    PluginSubmitCreditDecisionRequest
  >({
    mutationFn: (data) => runSubmitCreditDecisionRequest(constructPost, data),
    onError: (error: ApiErrorResponse) =>
      handleError(
        getApiErrorMessage(error, 'Failed to submit credit decision request'),
      ),
  });
  return { runSubmitCreditDecisionRequest: mutateAsync, ...rest };
};
